<template>
  <div>
    <template v-if="accounts.length > 0">
      <CardPartial
        v-for="(acc, key) in accounts"
        :key="key"
        :index="key"
        :account="acc"
        :selected="selected === acc.id"
        :deletable="canDeleteCards"
        @select="selectItem"
        @delete="deleteItem"
        @deleting="isDeleting"
      />
    </template>
    <div
      class="relative-position q-pa-md card-item"
      :class="{selected: selected === null}"
      tabindex="-1"
      @focus.capture="selectNewCard"
    >
      <q-icon
        name="done"
        class="checked"
      />
      <component
        :is="provider"
        v-if="provider !== null"
        ref="paymentProvider"
        :sample="sample"
        :setup-intent="setupIntent"
        @generated="finalisePayment"
        @capture="selectNewCard"
      />
    </div>
    <div
      v-if="withCoupon"
      class="flex justify-end q-pt-md q-pb-md"
    >
      <CouponInput
        v-model="coupon"
        outlined
        dense
      />
    </div>
    <div
      v-if="!sample"
      class="flex justify-end q-mt-md"
    >
      <div>
        <q-btn
          color="blue"
          :label="payLabel || 'Pay Now'"
          :loading="deleting || loading"
          @click="makePayment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CardPartial from './Card'
import CouponInput from './CouponInput.vue'

import stripe from './Stripe'
import square from './Square'

export default {
  components: {
    CardPartial, CouponInput, stripe, square
  },
  props: {
    sample: {
      type: Boolean,
      default: false
    },
    accounts: {
      type: Array,
      required: false,
      default: () => []
    },
    payLabel: {
      type: String,
      required: false,
      default: null
    },
    withCoupon: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    provider: {
      type: String,
      default: 'stripe'
    },
    canDeleteCards: {
      type: Boolean,
      default: false
    },
    setupIntent: {
      type: String,
      default: null
    }
  },
  emits: ['makePayment', 'onError'],
  data () {
    return {
      deleting: false,
      selected: null,
      coupon: null
    }
  },
  watch: {
    'accounts' (val) {
      const defaultCard = val.find(item => item.default === true)
      if (defaultCard) {
        this.selected = defaultCard.id
      }
      else {
        this.selected = null
      }
    }
  },
  methods: {
    selectItem (acc) {
      this.selected = acc
    },
    deleteItem (key) {
      this.accounts.splice(key, 1)
      this.selected = null
    },
    selectNewCard () {
      this.selected = null
    },
    async makePayment () {
      if (this.selected === null) {
        this.$refs.paymentProvider.makePayment()
      }
      else {
        this.$emit('makePayment', {
          type: 'existing',
          token: this.selected,
          coupon: this.coupon
        })
      }
    },
    finalisePayment ({ token, error }) {
      if (error) {
        if (Array.isArray(error)) {
          error = error[0]
        }
        this.$q.dialog({
          title: 'Error',
          message: error.message
        })
        this.$emit('onError')
        return
      }

      this.$emit('makePayment', {
        type: 'new',
        token,
        coupon: this.coupon
      })
    },
    isDeleting (val) {
      this.deleting = val
    }
  }
}
</script>

<style scoped lang="scss" src="src/css/components/payment.scss" />
